export const CONFIRMED_CREATE_DISEASE = "CONFIRMED_CREATE_DISEASE";
export const CONFIRMED_DELETE_DISEASE = "CONFIRMED_DELETE_DISEASE";
export const CONFIRMED_EDIT_DISEASE = "CONFIRMED_EDIT_DISEASE";
export const CONFIRMED_GET_DISEASES = "CONFIRMED_GET_DISEASES";
